/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemsContactFormSubmissions } from '../../models/items-contact-form-submissions';

export interface CreateItemsContactFormSubmissions$Params {

/**
 * What metadata to return in the response.
 */
  meta?: string;
      body?: (Array<ItemsContactFormSubmissions> | ItemsContactFormSubmissions)
}

export function createItemsContactFormSubmissions(http: HttpClient, rootUrl: string, params?: CreateItemsContactFormSubmissions$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: Array<ItemsContactFormSubmissions>;
}>> {
  const rb = new RequestBuilder(rootUrl, createItemsContactFormSubmissions.PATH, 'post');
  if (params) {
    rb.query('meta', params.meta, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: Array<ItemsContactFormSubmissions>;
      }>;
    })
  );
}

createItemsContactFormSubmissions.PATH = '/items/contact_form_submissions';
